import FamilyCardPage from '@/pages/FamilyCardPage';

export default [
    {
        path: '/rodzina/:id',
        props: { previousRouteName: 'families-to-accept' },
        component: FamilyCardPage,
        name: 'family-card',
        meta: { requiresAuth: true },
        children: []
    },
    {
        path: '/moja-rodzina/:id',
        props: { previousRouteName: 'families-list' },
        component: FamilyCardPage,
        name: 'my-family-card',
        meta: { requiresAuth: true },
        children: []
    },
    {
        path: '/rodzina-oczekujaca/:id',
        props: { previousRouteName: 'families-to-accept' },
        component: FamilyCardPage,
        name: 'pending-family-card',
        meta: { requiresAuth: true },
        children: []
    }
];
